import * as P from "fp-ts-routing";

export type DeployRoute = {};

export const deployPageMatch = P.lit("deploy");
